require('./cookie-access.less');

jQuery(function () {
    $('.js-more-cookie-text').on('click',function (e){
        e.preventDefault();
        $('.cookie-access__full-text').fadeToggle()
    });

    $('.js-cancel').on('click',function (e){
        e.preventDefault();
        $('.cookie-access').removeClass('cookie-access--active')
    });

    const container = document.querySelector('.cookie-access');
    if(container){
        if (document.cookie.indexOf("cookie-access") != -1) {
            container.classList.remove('cookie-access--active');
        }else{
            container.classList.add('cookie-access--active');
        }
        const apply = container.querySelectorAll('.js-agree');
        apply.forEach(button => {
            button.addEventListener('click', () => {
                container.classList.remove('cookie-access--active');
                document.cookie = 'cookie-access=true; max-age=2592000; path=/';
            });
        });
    }
});



// WEBPACK FOOTER //
// ./modules/cookie-access/cookie-access.js